module.exports = __webpack_public_path__ + "static/media/ice16.9f6d0219.webp";